export interface HiringSnapshotSeoRow {
  location: string;
  activeListings: number;
}

export function buildHiringSnapshotSeoRows(
  locationDistribution: Record<string, number> | null | undefined,
): HiringSnapshotSeoRow[] {
  if (!locationDistribution) return [];

  return Object.entries(locationDistribution)
    .map(([location, count]) => ({ location: location.trim(), activeListings: Number(count) }))
    .filter(
      (row) =>
        row.location.length > 0 &&
        Number.isFinite(row.activeListings) &&
        row.activeListings > 0,
    )
    .sort((a, b) => b.activeListings - a.activeListings);
}
